export default __webpack_public_path__ + "static/media/gukhwa-jang.33ef26c3.jpg";